import React from 'react';
import { Layout, Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  UserOutlined,
  ContactsOutlined,
  DollarOutlined,
  BarChartOutlined,
  SettingOutlined,
  TeamOutlined,
  CalendarOutlined,
  CheckSquareOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import useAuthStore from '../../store/authStore';

const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore();

  const isAdmin = user?.role === 'super_admin' || user?.role === 'tenant_admin';

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard'
    },
    {
      key: '/leads',
      icon: <ContactsOutlined />,
      label: 'Leads'
    },
    {
      key: '/deals',
      icon: <DollarOutlined />,
      label: 'Deals'
    },
    {
      key: '/meetings',
      icon: <CalendarOutlined />,
      label: 'Meetings'
    },
    {
      key: '/tasks',
      icon: <CheckSquareOutlined />,
      label: 'Tasks'
    },
    {
      key: '/analytics',
      icon: <BarChartOutlined />,
      label: 'Analytics'
    },
    {
      key: '/reports',
      icon: <FileTextOutlined />,
      label: 'Reports'
    },
    ...(isAdmin ? [{
      key: '/admin',
      icon: <TeamOutlined />,
      label: 'Admin',
      children: [
        {
          key: '/admin/users',
          label: 'Users'
        },
        {
          key: '/admin/settings',
          label: 'Settings'
        }
      ]
    }] : []),
    {
      key: '/profile',
      icon: <UserOutlined />,
      label: 'Profile'
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: 'Settings'
    }
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  const getSelectedKeys = () => {
    const path = location.pathname;
    if (path.startsWith('/admin')) {
      return [path];
    }
    return [path];
  };

  const getOpenKeys = () => {
    const path = location.pathname;
    if (path.startsWith('/admin')) {
      return ['/admin'];
    }
    return [];
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      className="shadow-lg"
      width={256}
      collapsedWidth={80}
      style={{
        background: '#1e3a8a',
        position: 'fixed',
        height: '100vh',
        left: 0,
        top: 0,
        zIndex: 1000 // Ensure it's above other content if needed
      }}
    >
      {/* Logo */}
      <div className="h-16 flex items-center justify-center border-b border-white border-opacity-20">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center">
            <img 
              src="/qqcrm-logo.png" 
              alt="QQCRM Logo" 
              className={`${collapsed ? 'h-6' : 'h-8'} w-auto filter brightness-0 invert transition-all duration-200`}
            />
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <Menu
        mode="inline"
        selectedKeys={getSelectedKeys()}
        defaultOpenKeys={getOpenKeys()}
        onClick={handleMenuClick}
        className="border-none bg-transparent"
        items={menuItems}
        theme="dark"
        style={{
          height: 'calc(100vh - 64px)',
          borderRight: 0,
          backgroundColor: 'transparent'
        }}
      />
    </Sider>
  );
};

export default Sidebar;
